import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClients_municipalityIdSubscriptionsCount = z.any()
export type TagsGetAdminClients_municipalityIdSubscriptionsCount = z.infer<typeof tagsGetAdminClients_municipalityIdSubscriptionsCount>

export const paramsGetAdminClients_municipalityIdSubscriptionsCount = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetAdminClients_municipalityIdSubscriptionsCount = z.infer<typeof paramsGetAdminClients_municipalityIdSubscriptionsCount>

export const responseGetAdminClients_municipalityIdSubscriptionsCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClients_municipalityIdSubscriptionsCount = z.infer<typeof responseGetAdminClients_municipalityIdSubscriptionsCount>

interface IGetAdminClients_municipalityIdSubscriptionsCount extends BaseMethodType {
  tags: TagsGetAdminClients_municipalityIdSubscriptionsCount,
  params: ParamsGetAdminClients_municipalityIdSubscriptionsCount,
  response: ResponseGetAdminClients_municipalityIdSubscriptionsCount
}
export const URL = '/admin/clients/:municipalityId/subscriptions/count'
export const validation = {
  get: {
    tags: tagsGetAdminClients_municipalityIdSubscriptionsCount,
    params: paramsGetAdminClients_municipalityIdSubscriptionsCount,
    response: responseGetAdminClients_municipalityIdSubscriptionsCount
  }
}
export interface AdminClients_municipalityIdSubscriptionsCount extends BaseRouteType {
  get: IGetAdminClients_municipalityIdSubscriptionsCount
}